import { LobbyFiltersComponent } from './../lobby-filters/lobby-filters.component';
import { TournamentpopupComponent } from './../tournamentpopup/tournamentpopup.component';
import { GamepreviewpopupComponent } from './../gamepreviewpopup/gamepreviewpopup.component';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { LobbyService } from './../_services/lobby.service';
import { Component, OnInit, OnDestroy, HostListener,ViewChild } from '@angular/core';
import { formatDate } from '@angular/common';
import { Store } from '@ngrx/store';
import { Subscription, interval ,forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material';
import moment from 'moment-timezone';
import { Router, ActivatedRoute } from '@angular/router';
import { NewsfeedComponent } from '../newsfeed/newsfeed.component';
import { VerificationComponent } from '../verification/verification.component';
import { AddfundPopupComponent } from '../addfund-popup/addfund-popup.component';
@Component({
   selector: 'app-resultboard',
  templateUrl: './lobby.component.html',
  styleUrls: ['./lobby.component.scss']
})

@HostListener('scroll', ['$event'])

export class LobbyComponent implements OnInit, OnDestroy {

  sub_isMobileScreen: Subscription;
  sub_balanceData: Subscription;
  sub_joinLeague: Subscription;
  sub_joinTournament: Subscription;
  sub_fillLeague: Subscription;
  sub_fillTournament: Subscription;
  sub_currentGame: Subscription;
  isMobile = false;
  leagues = [];
  user: any;
  emptyLobby = false;
  // game selector vars
  curGame = 'all';
  curGameAbbr = 'all';
  // sort vars
  tableSort = null;
  sortDirection = 'desc';
  // misc vars
  bucketURL = `${environment.assetURL}` + '/assets/default/images/';
  siteURL = `${environment.SITE_URL}`;
  prevScroll = 0;
  draftedToday = null;
  // filter vars
  showFilter = true;
  filters = null;
  // upcoming slate vars
  nextSlate = null;
  nextSlateGame = null;
  nextSlateClock = null;
  // timers
  lockClock = null;
  draftedClock = null;
  scrollBarWidth = 0;
  leagueLockCounter = {};
  leagueLockIntervalClock = {};
  leagueClockSet = {};
  isMac = false;
  darkMode= false;
  darkMode_ext= '';
  noDeposit = 0;
  firstLoad = 1;
  depositContent = '';
  depositTitle = '';
  redirect:String;
  showlobby=true;
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  version = '';
  @ViewChild(NewsfeedComponent,{}) feedChild: NewsfeedComponent;
  constructor(private store: Store<any>, private _lobbyService: LobbyService, public dialog: MatDialog,private router: Router, private activeRoute: ActivatedRoute) {
    this.scrollBarWidth = this.getScrollbarWidth();
    if (navigator.appVersion.indexOf("Mac")!=-1) this.isMac =true;
    if(router.url=='/user/refer-friend' || router.url=='/user/profile'){
      this.showlobby=false;
    }
  
    this.store.select('authData').subscribe(state => {
      if (localStorage.getItem('currentUser') == null) {
        // redirect to login page
        window.location.href = `${environment.SITE_URL}` + '/logout';
      }
      if (state[0]) {
        this.user = state[0];
        this.noDeposit = (this.user.successful_deposits != null && this.user.successful_deposits == 0) ? 1 : 0;
        /**Load filter only first not when any userdata modified */
        if(this.user) this.firstTimeDepositPopup();
        if(this.firstLoad == 1) {
          this.firstLoad = 0;
          this.getFilters();
        }
      }
    });
    this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
      if (state.length > 0) {
        this.isMobile = state[0];
      }
    });
    this.sub_balanceData = this.store.select('userBalance').subscribe(state => {
      if (state.length > 0) {
        this.user.dollar_balance = state[0];
        if(this.user.dollar_balance != 0) {
          this.noDeposit = 0;
        }
      }
    });
    this.sub_joinLeague = this._lobbyService.updateLeagueMember().subscribe(state => {
      if (state.status != null && state.status == 1) {
        let oldIndex = 0;
        let newIndex = 0;
        let currentJoined = 0;
        this.leagues.forEach((league, i) => {
          if (league.id == state.league_id) {
            oldIndex = i;
            if (state.action == 'join') {
              league.joined_entrants++;
              if (state.joined_mem != null && parseInt(state.joined_mem) == this.user.id) league.league_member = state.joined_mem;
            } else {
              league.joined_entrants--;
              if (state.joined_mem != null && parseInt(state.joined_mem) == this.user.id) league.league_member = null;
            }
            currentJoined = league.joined_entrants;
            league.updateStatus = true;
            setTimeout(() => {
              league.updateStatus = false;
            }, 1000);
          }
          else if (!newIndex && league.joined_entrants == 0 && league.tournament_id == '0') {
            newIndex = i;
          }
        });
        if (oldIndex && newIndex && (currentJoined == 1 || currentJoined == 0)) {
          this.moveLeague(oldIndex, newIndex);
        }
      }
    });
    this.sub_joinTournament = this._lobbyService.updateTournamentMember().subscribe(state => {
      if (state.status != null && state.status == 1) {
        let oldIndex = 0;
        let newIndex = 0;
        let currentJoined = 0;
        this.leagues.forEach((league, i) => {
          if (league.tournament_id == state.tournament_id && !league.updateStatus) {
            league.updateStatus = true;
            oldIndex = i;
            if (state.action == 'join') {
              if(state.entities.is_fast != null) {
                if(state.entities.is_fast == 1) {
                  league.league_joined_entrants = state.entities.draft_entries;
                }
                league.joined_entrants = state.entities.total_entries;
              } else {
                league.joined_entrants++;
                league.league_joined_entrants++;
              }
              
              if (league.league_joined_entrants == league.draft_size) {
                league.league_joined_entrants = 0;
              }
              
              if (state.joined_mem != null && parseInt(state.joined_mem) == this.user.id) league.league_member = state.joined_mem;
            } else {
              if(state.entities.is_fast != null) {
                if(state.entities.is_fast == 1) {
                  league.league_joined_entrants = state.entities.draft_entries;
                }
                league.joined_entrants = state.entities.total_entries;
              } else {
                league.joined_entrants--;
                league.league_joined_entrants--;
              }
              if (state.joined_mem != null && parseInt(state.joined_mem) == this.user.id) league.league_member = null;
            }
            currentJoined = league.joined_entrants;
            setTimeout(() => {
              league.updateStatus = false;
            }, 1000);
          }
          else if (!newIndex && league.joined_entrants == 0 && league.tournament_id != '0') {
            newIndex = i;
          }
        });
        if (oldIndex && newIndex && (currentJoined == 1 || currentJoined == 0)) {
          //this.moveLeague(oldIndex, newIndex);
        }
      }
    });
    this.sub_fillLeague = this._lobbyService.fillLeagueMember().subscribe(state => {
      if (state.status != null && state.status == 1) {
        this.leagues.forEach(league => {
          if (league.id == state.league_id) {
            this.leagues = this.leagues.filter(lg => lg.id != league.id);
          }
        });
      }
    });
    this.sub_fillTournament = this._lobbyService.fillTournamentMember().subscribe(state => {
      if (state.status != null && state.status == 1) {
        this.leagues.forEach(league => {
          if (league.tournament_id == state.tour_id) {
            this.leagues = this.leagues.filter(lg => lg.tournament_id != league.tournament_id);
          }
        });
      }
    });
    this.sub_currentGame = this._lobbyService.cgObservable.subscribe(state => {
      if (state.game != null && state.abbr != null && this.curGame != state.game) {
        this.curGame = state.game;
        this.curGameAbbr = state.abbr;
        this.leagues = [];
        this.emptyLobby = false;
        this.loadLobby();
      }
    });
    /*this._lobbyService.getDrafted().subscribe(state => {
      if (state.status == 'success') {
        this.draftedToday = state.leagues;
      }
    });*/
    // update once a minute
    /*this.draftedClock = setInterval(() => {
      this._lobbyService.getDrafted().subscribe(state => {
        if (state.status == 'success') {
          this.draftedToday = state.leagues;
        }
      });
    }, 60000);*/
    this.store.select('DarkModeReducer').subscribe(state => {
      if (state.length > 0) {
        this.darkMode = state[0].isDarkMode;
        this.darkMode_ext = this.darkMode?'-dark':'';
      }
    });
  }

  firstTimeDepositPopup(){
    this.activeRoute.queryParams.subscribe(params => {
      this.redirect = params['redirect'];
      const depsoit_status = params['depsoit'];
      const deposit_title = params['title'];
      const deposit_message = params['message'];
      if(this.user){
      const depositStaticContent = (this.user.payment_verified == 'N' && this.user.verify_before_deposits ) ? 'verifyaccount': 'specialoffer';
      this._lobbyService.getStaticContent(depositStaticContent).subscribe(res=>{
        if (res.status == 'success') {
          this.depositContent = res.entities.description;
          this.depositTitle = res.entities.title;
          if(this.redirect != null && this.redirect != '' && this.redirect == "popup/cashier"){
            this.dialog.closeAll();
            this.dialog.open(AddfundPopupComponent, {
              width: '850px',
              data: { 'tab': 1}
            });
          } else if(this.redirect != null && this.redirect != '' && this.redirect == "popup/verification"){
            setTimeout(()=>this.openVerificationDialog(),500);
          } else if(this.redirect != null && this.redirect != '') {
            this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
              width: '500px',
              data: { 'title': this.depositTitle, 'body': this.depositContent,'type':'first_deposit'}
            });
            this.confirmDialogRef.afterClosed().subscribe(res => {
              this.router.navigate(['/lobby']);
            });
          } else if(depsoit_status != null && depsoit_status !='') {
            this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
              width: '500px',
              data: { 'title': deposit_title, 'body': deposit_message,'type': (depsoit_status == 'success') ? 'deposit_success' : 'deposit_pending'}
            });
            this.confirmDialogRef.afterClosed().subscribe(res => {
              this.router.navigate(['/lobby']);
            });
          }
        }
      });
    }
    });
  }

  openLeague(league_id, tournament_id, remain_people): void {
    let dialogRef = null;
    if (tournament_id == 0) {
      dialogRef = this.dialog.open(GamepreviewpopupComponent, {
        width: '800px',
        data: { league_id },
        autoFocus: false
      });
    } else {
      dialogRef = this.dialog.open(TournamentpopupComponent, {
        width: '800px',
        data: {
          league_id,
          tournament_id,
          remain_people
        },
        autoFocus: false
      });
    }

    dialogRef.afterClosed().subscribe(result => {
       if(result!=undefined && result.route!=undefined)
       this.router.navigate(result.route);
    });
    dialogRef.componentInstance.closePopupAndNavigate.subscribe((route) => {
    dialogRef.close({'route':[route]})
    });
    
  }

  ngOnInit() {
    this.version = require('../../../package.json').version;
  }

  ngOnDestroy() {
    if (this.sub_isMobileScreen) { this.sub_isMobileScreen.unsubscribe(); }
    if (this.sub_currentGame) { this.sub_currentGame.unsubscribe(); }
    if (this.sub_fillLeague) { this.sub_fillLeague.unsubscribe(); }
    if (this.sub_fillTournament) { this.sub_fillTournament.unsubscribe(); }
    if (this.sub_joinLeague) { this.sub_joinLeague.unsubscribe(); }
    if (this.sub_joinTournament) { this.sub_joinTournament.unsubscribe(); }
    if (this.sub_balanceData) { this.sub_balanceData.unsubscribe(); }
  }

  getFilters() {
    this._lobbyService.getFilters(this.user.id).subscribe(res => {
      if (res != null && res.buyin != null && res.entrant != null && res.use != null && res.contests != null && res.game_id != null) {
        this.filters = res;
      } else {
        this.filters = {
          "apply_lobby_filter": "0",
          "buy_in_orderby": "DESC",
          "buyin": "0;10000",
          "entrant": "0;10000",
          "entrant_orderby": "DESC",
          "game_id": "all",
          "name": "",
          "orderby": "",
          "sortkey": "",
          "use": "false",
          "contests": "tiers,rankem,bestball,snake,gpp,multi,playoffs"
        };
      }
      this.loadLobby();
    });
  }

  getJoinedEntrantsWidth(league,type) {
    if(type){
      let a = [];
      if (league.tournament_id > 0) {
        for (let n = 0; n < league.draft_size; ++n) {
          a.push(n);
        }
      }
      else {
        for (let n = 0; n < league.entrants; ++n) {
          a.push(n);
        }
      }
      return a;
    }else{
      if (league.tournament_id > 0) {
        return 100 / parseInt(league.league_joined_entrants);
        // return (Math.floor(parseInt(league.league_joined_entrants) / parseInt(league.draft_size) * 100)) + '%';
      }
      else {
        return 100 / parseInt(league.joined_entrants);
        // return (Math.floor(parseInt(league.joined_entrants) / parseInt(league.entrants) * 100)) + '%';  
      }
    }
  }

  loadLobby() {
    this.leagues = [];
    this.leagueLockCounter = {};
    forkJoin({
      tournamentsRes: this._lobbyService.getTournaments(this.user.id, this.curGame),
      leaguesRes: this._lobbyService.getLeagues(this.user.id, this.curGame)
    }).subscribe(({ tournamentsRes, leaguesRes }) => {
      if (tournamentsRes.status == 'success') {
        tournamentsRes.entities.forEach(tournament => {
          if(tournament.tour_visibility == 'public' || this.user.ac_type == 'test') {
            tournament.tournament_id = tournament.id;
            tournament.id = tournament.league_id;
            tournament.league_member = (tournament.is_joined == 1) ? this.user.id : null;
            tournament.payout_amount = tournament.prize;
            switch (tournament.drafttype_id) {
              case 4:
                tournament.draft_type = 'Rank\'EM';
                break;
              case 5:
                tournament.draft_type = 'Classic Tiers';
                break;
              default:
                tournament.draft_type = 'Snake Draft';
                break;
            }
            tournament.earliest_game_schedule = tournament.pro_game_start_time;
            if (!this.leagueClockSet[tournament.draft_time]) {
              this.leagueLockClock(tournament.draft_time);
            }
            this.leagues.push(tournament);
          }
        });
        this.emptyLobby = false;
      }
      this.tableSort = null;
      this.sortDirection = 'desc';

      if (leaguesRes.status == 'success') {
        this.emptyLobby = false;
        leaguesRes.entities.forEach(league => {
          if(league.publish_to_lobby == 'lobby_live' || this.user.ac_type == 'test') {
            if (!this.leagueClockSet[league.draft_time]) {
              this.leagueLockClock(league.draft_time);
            }
            this.leagues.push(league);
          }
        });
      }
      //this.getNextSlate();
      this.emptyLobby = false;
      this.filterLobby();
    });
  }

  filterLobby() {
    if (this.filters != null && this.filters.use == 'true' && this.leagues.length) {
      // sports filter
      if (this.curGameAbbr == 'all' && this.filters.game_id != null && this.filters.game_id.split(',').indexOf('all') == -1) {
        this.leagues = this.leagues.filter(league => {
          return this.filters.game_id.indexOf(parseInt(league.game_id)) != -1;
        });
      }
      // entrants filter
      if (this.filters.entrant != null) {
        this.leagues = this.leagues.filter(league => {
          return (parseInt(league.entrants) >= parseInt(this.filters.entrant.split(';')[0]) && parseInt(league.entrants) <= parseInt(this.filters.entrant.split(';')[1]));
        });
      }
      // buyins filter
      if (this.filters.buyin != null) {
        this.leagues = this.leagues.filter(league => {
          return (parseFloat(league.buy_in_amount) >= parseFloat(this.filters.buyin.split(';')[0]) && parseFloat(league.buy_in_amount) <= parseFloat(this.filters.buyin.split(';')[1]));
        });
      }
      //search string
      if (this.filters.name != null && this.filters.name != '') {
        const regex = new RegExp(this.filters.name, "gi");
        this.leagues = this.leagues.filter(league => {
          return league.name.match(regex) != null;
        });
      }
      // subtractive contests filter
      if (this.filters.contests != null && this.filters.contests.split(',').length) {
        const contests = this.filters.contests.split(',');
        // tiers
        if (contests.indexOf('tiers') == -1) {
          this.leagues = this.leagues.filter(league => league.drafttype_id != 5);
        }
        // rankem
        if (contests.indexOf('rankem') == -1) {
          this.leagues = this.leagues.filter(league => league.drafttype_id != 4);
        }
        // bestball
        if (contests.indexOf('bestball') == -1) {
          this.leagues = this.leagues.filter(league => league.duration_id != 8);
        }
        // snake
        if (contests.indexOf('snake') == -1) {
          this.leagues = this.leagues.filter(league => league.tournament_id > 0 || league.drafttype_id != 1 || (league.duration_id != 1 && league.duration_id != 2));
        }
        // gpp
        if (contests.indexOf('gpp') == -1) {
          this.leagues = this.leagues.filter(league => league.tournament_id == 0 || league.is_mode != 'gpp');
        }
        // multi
        if (contests.indexOf('multi') == -1) {
          this.leagues = this.leagues.filter(league => league.tournament_id == 0 || league.is_mode != 'normal');
        }
        // playoffs
        if (contests.indexOf('playoffs') == -1) {
          this.leagues = this.leagues.filter(league => league.duration_id != 5 && league.duration_id != 6);
        }
      }
      // buyins sort
      if (this.filters.buy_in_orderby != null) {
        this.leagues.sort((a, b) => {
          return (this.filters.buy_in_orderby == 'ASC') ? ((a.buy_in_amount > b.buy_in_amount) ? 1 : -1) : ((a.buy_in_amount > b.buy_in_amount) ? -1 : 1);
        });
      }
      // entrant sort
      if (this.filters.entrant_orderby != null) {
        this.leagues.sort((a, b) => {
          return (this.filters.entrant_orderby == 'ASC') ? ((a.entrants > b.entrants) ? 1 : -1) : ((a.entrants > b.entrants) ? -1 : 1);
        });
      }
      // tournaments to the top
      this.leagues.sort((a, b) => {
        return (a.tournament_id > b.tournament_id) ? -1 : 1;
      });
      // // contests filter (snake/rankem)
      // if (this.filters.contests != null && this.filters.contests.indexOf('all') == -1){
      //   this.leagues = this.leagues.filter(league=>{
      //     return ((this.filters.contests.indexOf('snake') > -1 && league.drafttype_id == 1) || (this.filters.contests.indexOf('rankem') > -1 && league.drafttype_id == 4));
      //   });
      // }
    }
    if (this.leagues.length) {
      this.emptyLobby = false;
    } else {
      this.emptyLobby = true;
    }
  }

  trackLeague(index, item) {
    return item.id;
  }

  getSchedule(duration, egs, lgs, week, game_id, tournament_id) {
    moment.tz.setDefault("America/New_York");
    switch (duration) {
      case '2':
        return (tournament_id > 0) ? moment.unix(egs).format('ddd, MMM DD') : 'Week ' + week;
        break;
      case '5':
        return 'Full Playoffs';
        break;
      case '6':
        return 'Playoff Round';
        break;
      case '8':
        //return (game_id == '2') ? 'Week 1 - 16' : (game_id == '4') ? 'Week 1 - 19' : 'Regular Season';
        return moment.unix(egs).format('ddd, MMM DD');
        break;
      case '7':
        return moment.unix(egs).format('ddd ') + '-' + moment.unix(lgs).format('ddd ') + '(' + moment.unix(lgs).format('MMM') + ' ' + moment.unix(egs).format('DD') + '-' + moment.unix(lgs).format('DD') + ')';
        break;
      default:
        return moment.unix(egs).format('ddd, MMM DD');
        break;
    }
  }

  sortTable(sort, type) {
    if (this.tableSort == sort) this.sortDirection = (this.sortDirection == 'asc') ? 'desc' : 'asc';
    this.tableSort = sort;
    const sortMod = (this.sortDirection == 'asc') ? -1 : 1;
    this.leagues.sort((a, b) => {
      // tournaments over regular leagues
      if (a.tournament_id > 0 && b.tournament_id == 0) {
        return -1;
      } else if (a.tournament_id == 0 && b.tournament_id > 0) {
        return 1;
      }
      if (type == 0) {
        return (a[sort] < b[sort]) ? sortMod : sortMod * -1;
      } else if (type == 1) {
        return (parseInt(a[sort]) < parseInt(b[sort])) ? sortMod : sortMod * -1;
      } else if (type == 2) {
        return (parseFloat(a[sort]) < parseFloat(b[sort])) ? sortMod : sortMod * -1;
      }
    });
  }

  lobbyScroll(event) {
    /*const scrollDirection = (this.prevScroll > event.target.scrollTop) ? 'up' : 'down';
    if (scrollDirection == 'up') {
      this.showFilter = true;
    } else {
      this.showFilter = false;
    }*/
    this.prevScroll = event.target.scrollTop;
  }

  getNextSlate() {
    let earliestSlate = 9999999999;
    let earliestGame = null;
    this.leagues.forEach(league => {
      if (league.earliest_game_schedule < earliestSlate) {
        earliestSlate = league.earliest_game_schedule;
        earliestGame = league.league_type.toLowerCase();
      }
    });
    this.nextSlate = earliestSlate;
    this.nextSlateGame = earliestGame;
    if (this.nextSlateGame != null) {
      this.upcomingLock();
    } else {
      this.nextSlateClock = null;
      clearInterval(this.lockClock);
    }
  }
  
  lpad(int) {
    return String(int).length == 1 ? '0' + String(int) : String(int);
  }

  upcomingLock() {
    clearInterval(this.lockClock);
    this.lockClock = setInterval(() => {
      var now = Math.floor(Date.now()/1000);
      var diff = this.nextSlate - now; //in seconds
      var hours = Math.floor((diff/60)/60);
      var mins = Math.floor((diff/60) - (hours*60));
      var seconds = Math.floor(diff - hours*3600 - mins*60);
      if (hours < 0 || mins < 0 || seconds < 0){
        this.nextSlateClock = 'Live!';
      } else {
        this.nextSlateClock = 'Until lock: ' + this.lpad(hours)+':'+this.lpad(mins)+':'+this.lpad(seconds);
      }
    }, 1000);
  }
  
  leagueLockClock(draft_time) {
    this.leagueClockSet[draft_time] = true;
    if (this.leagueLockIntervalClock[draft_time]) {
      clearInterval(this.leagueLockIntervalClock[draft_time]);
    }
    this.leagueLockIntervalClock[draft_time] = setInterval(() => {
      var now = Math.floor(Date.now()/1000);
      var diff = draft_time - now; //in seconds
      var hours = Math.floor((diff/60)/60);
      var mins = Math.floor((diff/60) - (hours*60));
      var seconds = Math.floor(diff - hours*3600 - mins*60);
      if (hours < 0 || mins < 0 || seconds < 0){
        clearInterval(this.leagueLockIntervalClock[draft_time]);
        this.leagues = this.leagues.filter(l => l.draft_time != draft_time);
        delete this.leagueLockCounter[draft_time];
      }
      else if (hours > 24) {
        this.leagueLockCounter[draft_time] = false;
      }
      else {
        this.leagueLockCounter[draft_time] = this.lpad(hours)+':'+this.lpad(mins)+':'+this.lpad(seconds);
      }
    }, 100);
  }
  
  openFilters() {
    let dialogRef = null;
    if (this.isMobile) {
      dialogRef = this.dialog.open(LobbyFiltersComponent, {
        width: '75%',
        data: {
          user_id: this.user.id,
          filters: this.filters
        },
        autoFocus: false
      });
    } else {
      dialogRef = this.dialog.open(LobbyFiltersComponent, {
        width: '650px',
        data: {
          user_id: this.user.id,
          filters: this.filters
        },
        autoFocus: false
      });
    }

    dialogRef.afterClosed().subscribe(res => {
      if (res != null && res.game_id != null) {
        this.filters = res;
        this.loadLobby();
      }
    });
  }

  moveLeague(oldIndex, newIndex) {
    if (newIndex >= this.leagues.length) {
      newIndex = this.leagues.length - 1;
    }
    this.leagues.splice(newIndex, 0, this.leagues.splice(oldIndex, 1)[0]);
    return;
  }

  lobbyScrolling(elm) {
    return elm.scrollHeight > elm.clientHeight;
  }

  getScrollbarWidth() {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }

  disableFilters() {
    this.filters.use = 'false';
    this.filters.apply_lobby_filter = '0';
    this.loadLobby();
    this._lobbyService.storeFilters(this.filters, this.user.id).subscribe(state => {
      // nothing
    });
  }
  
  lRowVisible(index, container) {
    const rowH = 49;
    const topIndex = Math.floor(container.scrollTop / rowH);
    const bottomIndex = Math.ceil((container.scrollTop + container.clientHeight) / rowH);
    return index >= topIndex && index < bottomIndex;
  }

  makePayment() {
    if(this.user.payment_verified === 'N' && this.user.verify_before_deposits){
      this.openVerificationDialog();
    }
    else {
      window.location.href = `${environment.SITE_URL}/drafts/register/welcome`;
    }
  }

  openVerificationDialog(){
    this.dialog.closeAll();
    this.dialog.open(VerificationComponent, {
      width:'500px',
      data: {
        user : this.user,
        lobby : true
      }
    })
  }

  openAddfundPopupComponent(){
    this.dialog.closeAll();
    this.dialog.open(AddfundPopupComponent, {
      width: '850px',
      data: { 'tab': 1}
    });
  }
}
